import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { trackButtonClick } from '../utils/analytics';

const Header = () => {
  const [scrolled, setScrolled] = useState(false);

  const handleDemoClick = () => {
    trackButtonClick('request_demo', 'header_section');
  };

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 10) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 py-4 ${scrolled ? 'bg-black bg-opacity-95 shadow-md' : 'bg-transparent'} transition-all duration-300`}>
      <div className="container mx-auto px-4 flex justify-between items-center">
        <div className="flex items-center">
          {/* Logo and brand with negative margin on text to bring it closer */}
          <Link to="/" className="flex items-center">
            <img 
              src="/images/revelio_logo.svg" 
              alt="Revelio AI Logo" 
              className="h-8 w-8 rounded-full bg-blue-500 mr-2" /* Increased height to h-20 */
            />
            <span className="font-bold text-2xl text-white">
              Revelio <span className="text-blue-500">AI</span>
            </span>
          </Link>
        </div>
        <nav className="hidden md:flex space-x-8">
          <a href="#products" className="text-gray-300 hover:text-blue-500">Products</a>
          <a href="#resources" className="text-gray-300 hover:text-blue-500">Resources</a>
          <a href="#company" className="text-gray-300 hover:text-blue-500">Company</a>
        </nav>
        <div>
          <Link to="/demo" className="bg-red-600 hover:bg-red-700 text-white font-medium py-2 px-4 rounded mr-3" onClick={handleDemoClick}>
            Get a Demo
          </Link>
        </div>
      </div>
    </header>
  );
};

export default Header;